var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{attrs:{"size":"32","color":"grey"}},[(_vm.value.avatar)?_c('v-img',{attrs:{"src":_vm.value.avatar}}):_c('v-icon',[_vm._v("mdi-account")])],1),_c('span',{staticClass:"ml-2",domProps:{"textContent":_vm._s(`${_vm.value.lastName}, ${_vm.value.firstName} (${_vm.value.code})`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }